var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, STACK_GAP, StackView } from "../../StackView";
import { Text, TEXT_SIZE, TEXT_VIEW } from "../../Text";
import { ArrowIcon } from "../../ArrowIcon";
import { createUIElement, KeyCode } from "../../helpers";
import { calcWidth } from "../../helpers/styles";
import { Icon } from "../../Icon";
import { GrowView } from "../../layouts";
import { ARROW_DIRECTION, CONTROL_SIZE } from "../../common/public";
import { useTooltip } from "../../Tooltip";
import { onMouseEnterHandlerDecorator, TooltipText } from "../../Grid/cellRenderers/helpers";
var DEFAULT_MAX_WIDTH_TOOLTIP = '720px';
var Button = styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    display: inline-flex;\n    max-width: 100%;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 0;\n    outline: none;\n    padding: ", ";\n    margin: 0;\n    height: 32px;\n    max-width: ", "; //\n\n    ", "\n\n    &:focus {\n        ", "\n    }\n\n    &:hover {\n        ", "\n    }\n\n    &:active {\n        ", "\n    }\n\n    ", "\n\n    > * {\n        max-width: 100%;\n    }\n"], ["\n    display: inline-flex;\n    max-width: 100%;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 0;\n    outline: none;\n    padding: ", ";\n    margin: 0;\n    height: 32px;\n    max-width: ", "; //\n\n    ",
    "\n\n    &:focus {\n        ",
    "\n    }\n\n    &:hover {\n        ",
    "\n    }\n\n    &:active {\n        ",
    "\n    }\n\n    ",
    "\n\n    > * {\n        max-width: 100%;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return "0 " + theme.spacing.s;
}, function (_a) {
    var size = _a.size;
    return (typeof size === 'string' ? size : calcWidth(size));
}, function (_a) {
    var disabled = _a.disabled;
    return !disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            cursor: pointer;\n        "], ["\n            cursor: pointer;\n        "])));
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled, active = _a.active, error = _a.error;
    return !disabled &&
        !active && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                background: ", ";\n            "], ["\n                background: ",
        ";\n            "])), !disabled && error
        ? theme.colorHighlightErrorLight
        : theme.colorHighlightLight);
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled, active = _a.active, error = _a.error;
    return !disabled &&
        !active && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                background: ", ";\n            "], ["\n                background: ",
        ";\n            "])), !disabled && error
        ? theme.colorHighlightErrorLight
        : theme.colorHighlightLight);
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled, error = _a.error;
    return !disabled && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                background: ", ";\n            "], ["\n                background: ",
        ";\n            "])), !disabled && error
        ? theme.colorHighlightErrorDark
        : theme.colorHighlightDark);
}, function (_a) {
    var active = _a.active, disabled = _a.disabled, theme = _a.theme, error = _a.error;
    return !disabled &&
        active && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            background: ", ";\n        "], ["\n            background: ",
        ";\n        "])), !disabled && error
        ? theme.colorHighlightErrorDark
        : theme.colorHighlightDark);
});
var ControlTextWithTooltip = function (_a) {
    var disabled = _a.disabled, error = _a.error, controlText = _a.controlText;
    var ref = useRef(null);
    return useTooltip({
        maxWidth: DEFAULT_MAX_WIDTH_TOOLTIP,
        renderContent: function () { return React.createElement(TooltipText, { size: TEXT_SIZE.s }, controlText); },
        render: function (tooltipProps) {
            return (React.createElement(GrowView, null,
                React.createElement(Text, __assign({}, tooltipProps, { ref: ref, view: (disabled && TEXT_VIEW.secondary) ||
                        (error && TEXT_VIEW.error) ||
                        TEXT_VIEW.link, truncate: true, onMouseEnter: onMouseEnterHandlerDecorator(tooltipProps.onMouseEnter, ref), onMouseLeave: tooltipProps.onMouseLeave }), controlText)));
        }
    });
};
export var SelectButton = createUIElement('SelectButton', function (_a, ref) {
    var className = _a.className, disabled = _a.disabled, _b = _a.placeholder, placeholder = _b === void 0 ? 'Not chosen...' : _b, active = _a.active, size = _a.size, error = _a.error, children = _a.children, text = _a.text, onKeyDownActivate = _a.onKeyDownActivate, iconBefore = _a.iconBefore, _c = _a.iconAfter, iconAfter = _c === void 0 ? React.createElement(ArrowIcon, { direction: ARROW_DIRECTION.down }) : _c, onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "disabled", "placeholder", "active", "size", "error", "children", "text", "onKeyDownActivate", "iconBefore", "iconAfter", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var controlText = text || children || placeholder || '';
    return (React.createElement(Button, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'selectbutton', className: "vm-SelectButton " + className, active: active, disabled: disabled, error: error, size: size || CONTROL_SIZE.full, onFocus: onFocus, onBlur: onBlur, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: function (e) {
            if (e.keyCode === KeyCode.Space || e.keyCode === KeyCode.Enter) {
                onKeyDownActivate === null || onKeyDownActivate === void 0 ? void 0 : onKeyDownActivate();
            }
            onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
        }, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(StackView, { direction: STACK_DIRECTION.row, gap: STACK_GAP.s, align: STACK_ALIGN.center, distribution: STACK_DISTRIBUTION.start },
            iconBefore && React.createElement(Icon, { src: iconBefore, error: error, disabled: disabled }),
            controlText && (React.createElement(ControlTextWithTooltip, { disabled: disabled, error: error, controlText: text || children || placeholder })),
            iconAfter && React.createElement(Icon, { src: iconAfter, error: error, disabled: disabled }))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=SelectButton.js.map